import { create } from "zustand";

interface LoaderState {
  activeLoader: boolean;
  upLoader: () => void;
  downLoader: () => void;
}

export const useLoader = create<LoaderState>((set) => ({
  activeLoader: false,
  upLoader: () => set({ activeLoader: true }),
  downLoader: () => set({ activeLoader: false }),
}));
